// extracted by mini-css-extract-plugin
module.exports = {"chart":"chart___2DMBD","empty":"empty___1ATJw","skeleton":"skeleton___3bPUw","pg-skeleton":"pg-skeleton___rlDaN"};